/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'

import DashboardMobileNav from '../../navigation.components/DashboardMobileNav';
import UserDashBoardSideNavigation from
  '../../dashboard.components/userDashBoard.components/UserDashBoardSideNavigation';
import UserDashBoardTopNavigation from
  '../../dashboard.components/userDashBoard.components/UserDashBoardTopNavigation';
import trophyIcon from '../../../template/utils/icons/trophy.png';

/**
 * @class SuccessOnQuestionaire
 */
class SuccessOnQuestionaire extends Component {
  /**
   *
   * @returns {*} - render
   */
  render() {
    const { data, history } = this.props;
    return (
      <>
        <DashboardMobileNav />
        <UserDashBoardSideNavigation />
        <div className="main_body_wrapper">
          <UserDashBoardTopNavigation />
          <section className="body_space">
            <div className="go_back">
              <span onClick={history.goBack}>
                <i className="fa fa-arrow-left" aria-hidden="true" />
                {' '}
                {'  '}
             Go Back
              </span>
            </div>
            <div className="question_main_wrapper">
              <div className="last_phase">
                <div className="trophy_icon">
                  <div>
                    <img src={trophyIcon} alt="" />
                  </div>
                </div>

                <div className="assess_text">
                  <p>
                Your Assesment
                  </p>
                  <span>
                 From the assesment you have just completed you are
                  </span>
                  <h3>
                    {data.investmentProfile}
                  </h3>
                </div>

                <div className="recomendation">
                  <div className="recom_text">
                    <p>
                  It is recommended you invest either of these
                    </p>
                  </div>
                  <div className="recom_options">
                    <div className="recom_options_div">
                      <Link to="/mutual-market-fund"
                        style={{ textDecoration: 'none' }}
                      >
                        <p>
                    Meristem Money Market Mutual Fund
                        </p>
                      </Link>
                    </div>
                    <div className="recom_options_div">
                      <Link to="/mutual-equity-fund"
                        style={{ textDecoration: 'none' }}
                      >
                        <p>
                    Meristem Equity Market Mutual Fund
                        </p>
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="next_question_btn">
                  <div className="prev_btn">
                    <Link to="/mutual-fund">
                      <button className="prev" type="button">
                        <i className="fas fa-long-arrow-alt-left" />
                        {' '}
Start Over
                      </button>
                    </Link>
                  </div>

                  <div className="next_btn">
                    <Link to="/mutual-fund-service-plans">
                      <button className="next" type="button">
                            Invest Now
                      </button>
                    </Link>
                  </div>

                </div>

              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

SuccessOnQuestionaire.propTypes = {
  data: PropTypes.any,
  history: PropTypes.shape({}),
};

const mapStateToProps = state => ({
  data: state.postRoboAdvisory.data,
});

export default withRouter(connect(mapStateToProps, null)(SuccessOnQuestionaire));
